import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";

const Testimonial = ({ blok }) => {
  const textColour =
    blok.content_type === "magazine" ? blok.text_colour : "#FFFFFF";

  const quote =
    blok.content_type === "magazine"
      ? "font-insights-display text-2xl md:text-3xl"
      : "font-display text-4xl md:text-5xl md:leading-[0.9]";

  const name =
    blok.content_type === "magazine" ? (
      <div
        className="font-insights-body text-base"
        style={{ color: textColour }}
      >
        {blok.name}
      </div>
    ) : (
      <div className={`font-body text-sm font-semibold ${blok.blok_colour !== 'darkgrey' && blok.blok_colour !== '' ? 'text-white' : 'text-red'}`}>
        {blok.name}
      </div>
    );

  const quoteBy =
    blok.content_type === "magazine" ? "font-insights-body" : "font-body";

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div
        className={`mx-auto text-center ${quote}`}
        style={{ color: textColour }}
      >
        <RichText>{blok.content}</RichText>
        {(blok.job_title || blok.name) &&
          <footer className="mt-4">
            <div className="flex flex-col items-center justify-center">
              <div className="mt-3 text-center md:mt-0 md:flex md:flex-col md:items-center">
                {name}
                <div className={`text-sm ${quoteBy}`} style={{ color: textColour }}>
                  {blok.job_title}
                </div>
              </div>
            </div>
          </footer>
        }
      </div>
    </SbEditable>
  );
};

export default Testimonial;
